/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Cta_PInputs */

const es_gift_cta_p = /** @type {(inputs: Gift_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un código, miles de salidas posibles. Alquileres y experiencias en toda la costa.`)
};

const gl_gift_cta_p = /** @type {(inputs: Gift_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un código, miles de saídas posibles. Alugueiros e experiencias en toda a costa.`)
};

const en_gift_cta_p = /** @type {(inputs: Gift_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One code, thousands of trips. Rentals and experiences along the coast.`)
};

/**
* | output |
* | --- |
* | "One code, thousands of trips. Rentals and experiences along the coast." |
*
* @param {Gift_Cta_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_cta_p = /** @type {((inputs?: Gift_Cta_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Cta_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_cta_p(inputs)
	if (locale === "en") return en_gift_cta_p(inputs)
	return es_gift_cta_p(inputs)
});